// cambia testo abc a seconda di opzioni attivate.
export const manipulateMelodyByConfig = (melody, staffOrientation, notesNameVisible, noteLengthVisible) => {
  // melody contiene lo spartito in formato abc. se non vogliamo vedere le note (vanno messe in lyric-line)
  // rimuoviamo le righe con "w:"
  let currentMelody = melody;
  currentMelody = '%%vocalfont sans-serif 10\n%%printtempo 0\n' + currentMelody;
  if (staffOrientation === 'vertical' || !notesNameVisible) {
    currentMelody = currentMelody.replace(/^w:.*\n?/gm, '');
  }
  if (staffOrientation === 'horizontal' && (notesNameVisible || noteLengthVisible)) {
    currentMelody = '%%staffsep 60\n' + currentMelody;
  }
  return currentMelody;
};
